export const SET_ACTIVE = 'playerBonus:set_active';
export const SET_HISTORY = 'playerBonus:set_history';
export const START_LOADING = 'playerBonus:start_loading';
export const STOP_LOADING = 'playerBonus:stop_loading';
export const RESET = 'playerBonus:reset';
